import React from 'react';
import type { Todo } from '../types';
import type { FormData } from '../utils/formUtils';
import type { TaskFieldSettings } from '../hooks/useTaskFieldSettings';

interface TeamMember {
  id: string;
  name: string;
  email: string;
}

interface TodoFormTeamFieldsProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  fieldSettings: TaskFieldSettings;
  todo?: Todo;
  teamMembers: TeamMember[];
}

const TodoFormTeamFields: React.FC<TodoFormTeamFieldsProps> = ({
  formData,
  setFormData,
  fieldSettings,
  todo,
  teamMembers,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Creator/Owner Field - shown for existing tasks in team mode only */}
      {todo && (
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Creator/Owner
          </label>
          <div className="input-field bg-gray-50 text-gray-600">
            {(() => {
              if (todo.creator_id && teamMembers.length > 0) {
                const creator = teamMembers.find(m => m.id === todo.creator_id);
                return creator ? `${creator.name} (${creator.email})` : 'Unknown';
              }
              return todo.creator_id ? 'Creator ID: ' + todo.creator_id : 'Unknown';
            })()}
          </div>
        </div>
      )}

      {/* Assignee Field */}
      {fieldSettings.assignedTo && (
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Assigned To
          </label>
          <select
            value={formData.assigned_to_id}
            onChange={(e) => setFormData({ ...formData, assigned_to_id: e.target.value })}
            className="input-field"
          >
            <option value="">Unassigned</option>
            {teamMembers.map(member => (
              <option key={member.id} value={member.id}>
                {member.name} ({member.email})
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default TodoFormTeamFields;
